<template>
	<lcsj-dialog v-model="showDialog" ref="processOrderEditDialog" :title="title" width="80%" append-to-body @close="closeDialog" cancel-text="关闭" confirm-text="保存" :confirm-loading="isSubmitting" @confirm="submitForm"><el-form ref="editForm" :model="editForm" :rules="rules" label-width="110px" size="small">
			<el-row :gutter="10">
				<el-col :span="8">
					<el-form-item label="订单编号：">
						<el-input v-model="editForm.orderNo" clearable placeholder="保存后自动生成" disabled></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="需求门店：" prop="belongStoreKeyId">
						<el-select filterable v-model="editForm.belongStoreKeyId" placeholder="请选择需求门店" clearable style="width: 100%">
							<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="加工类型：" prop="processType">
						<el-select v-model.number="editForm.processType" placeholder="请选择加工类型" style="width: 100%" @change="handleProcessTypeChange">
							<el-option v-for="item in processTypeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="10">
				<el-col :span="8">
					<el-form-item label="顾客：" prop="customerKeyId">
						<el-input v-model="customerDisplay" clearable readonly placeholder="请选择顾客" @focus="handleSelectCustomer">
							<el-button slot="append" icon="el-icon-search" @click="handleSelectCustomer">选择</el-button>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="下单日期：">
						<el-date-picker v-model="editForm.orderDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" placeholder="请选择下单日期" style="width: 100%"></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="取单日期：">
						<el-date-picker v-model="editForm.getOrderDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd" placeholder="请选择取单日期" style="width: 100%"></el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row :gutter="10">
				<el-col :span="8">
					<el-form-item label="加工方式：">
						<el-select v-model.number="editForm.machinType" placeholder="请选择加工方式" clearable style="width: 100%">
							<el-option v-for="item in machinTypeList" :key="item.code" :label="item.name" :value="Number(item.code)"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="验光师：">
						<el-input v-model="editForm.yanGuangShi" clearable placeholder="请输入验光师"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="镜架信息：">
						<el-input v-model="editForm.jjInformation" clearable placeholder="请输入镜架信息"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-form-item label="备注：">
				<el-input v-model="editForm.remark" clearable type="textarea" :rows="2" placeholder="请输入备注"></el-input>
			</el-form-item>
		</el-form>

		<el-descriptions class="margin-top" title="顾客信息" :column="6" border size="small">
			<el-descriptions-item label="顾客姓名">{{ transformEmpty(customerInfo.name) }}</el-descriptions-item>
			<el-descriptions-item label="性别">{{ transformGender(customerInfo.gender) }}</el-descriptions-item>
			<el-descriptions-item label="年龄">{{ transformEmpty(customerInfo.age) }}</el-descriptions-item>
			<el-descriptions-item label="顾客电话">{{ transformEmpty(customerInfo.phone) }}</el-descriptions-item>
			<el-descriptions-item label="所属门店" span="3">{{ transformEmpty(customerInfo.belongStoreName) }}</el-descriptions-item>
			<el-descriptions-item label="(右眼)球镜">{{ transformEmpty(customerInfo.rParams.qiuJing) }}</el-descriptions-item>
			<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.rParams.zhuJing) }}</el-descriptions-item>
			<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.rParams.zhouWei) }}</el-descriptions-item>
			<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}</el-descriptions-item>
			<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.rParams.tongJu) }}</el-descriptions-item>
			<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.rParams.tongGao) }}</el-descriptions-item>
			<el-descriptions-item label="(左眼)球镜">{{ transformEmpty(customerInfo.lParams.qiuJing) }}</el-descriptions-item>
			<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.lParams.zhuJing) }}</el-descriptions-item>
			<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.lParams.zhouWei) }}</el-descriptions-item>
			<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}</el-descriptions-item>
			<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.lParams.tongJu) }}</el-descriptions-item>
			<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.lParams.tongGao) }}</el-descriptions-item>
		</el-descriptions>

		<div class="detail-block-title">
			<span>加工明细</span>
			<span class="detail-tip">镜片须左右眼各一片，请先选择顾客后再选择镜片</span>
		</div>
		<el-table class="lcsj-data-table" :data="editForm.dtls" border size="small" style="width: 100%">
			<el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
			<el-table-column label="左右眼" width="80" align="center">
				<template #default="scope">{{ scope.row.lr === 1 ? "左眼" : "右眼" }}</template>
			</el-table-column>
			<el-table-column label="商品品牌" width="140" align="center">
				<template #default="scope">{{ scope.row.goodsBrand || "--" }}</template>
			</el-table-column>
			<el-table-column label="商品名称" min-width="180" align="center">
				<template #default="scope">{{ scope.row.goodsName || "--" }}</template>
			</el-table-column>
			<el-table-column label="球镜" width="90" align="center">
				<template #default="scope">{{ scope.row.qiuJing || "--" }}</template>
			</el-table-column>
			<el-table-column label="柱镜" width="90" align="center">
				<template #default="scope">{{ scope.row.zhuJing || "--" }}</template>
			</el-table-column>
			<el-table-column label="轴位" width="110" align="center">
				<template #default="scope">
					<el-input v-model.number="scope.row.zhouWei" size="small" type="number" placeholder="轴位"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="数量" width="110" align="center">
				<template #default="scope">
					<el-input v-model.number="scope.row.quantity" size="small" type="number" placeholder="数量"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="备注" min-width="140" align="center">
				<template #default="scope">
					<el-input v-model="scope.row.remark" size="small" clearable placeholder="备注"></el-input>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120" align="center" fixed="right">
				<template #default="scope">
					<el-button type="primary" size="small" @click="handleSelectGoods(scope.$index)">选择镜片</el-button>
				</template>
			</el-table-column>
		</el-table>



		<selectGoods ref="selectGoods"></selectGoods>
		<selectCustomer ref="selectCustomer"></selectCustomer>
	</lcsj-dialog>
</template>

<script>
import { GetProcessOrderInfo, GenerateProcessOrderNumber, CreateProcessOrder, EditProcessOrder } from "@/api/processApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import selectGoods from "@/views/baseData/goods/selectGoods.vue";
import selectCustomer from "@/views/baseData/customer/selectCustomer.vue";
// 生成一条空的加工明细行；lr：0=右眼 1=左眼（与门店订单、加工订单详情保持一致）
function buildEmptyDtl(lr) {
	return {
		keyId: "",
		goodsKeyId: "",
		goodsBrand: "",
		goodsName: "",
		qiuJing: "",
		zhuJing: "",
		lr: lr,
		zhouWei: 0,
		quantity: 1,
		remark: ""
	};
}
export default {
	watch: {
		showDialog(visible) {
			if (!visible) return;
			this.GetOrgInfoListByConfig();
			this.getEnumConfig();
		}
	},
	components: {
		selectGoods,
		selectCustomer
	},
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			title: "新建加工订单",
			saveLoading: false,
			editType: 1, // 1新增 2编辑
			storeList: [],
			processTypeList: [],
			machinTypeList: [],
			customerDisplay: "",
			// 顾客信息（含左右眼验光参数）；未选顾客时各项为空
			customerInfo: {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: "",
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			},
			// 当前正在选择镜片的明细行下标（0=右眼行 1=左眼行）
			selectDtlIndex: 0,
			editForm: {
				keyId: "",
				orderNo: "",
				belongStoreKeyId: "",
				processType: 1,
				customerKeyId: "",
				orderDate: "",
				getOrderDate: "",
				yanGuangShi: "",
				jjInformation: "",
				machinType: 1,
				remark: "",
				// 固定两行：第 1 行右眼、第 2 行左眼
				dtls: [buildEmptyDtl(0), buildEmptyDtl(1)]
			},
			rules: {
				belongStoreKeyId: [{ required: true, message: "请选择需求门店", trigger: "change" }],
				processType: [{ required: true, message: "请选择加工类型", trigger: "change" }],
				customerKeyId: [{ required: true, message: "请选择顾客", trigger: "change" }]
			}
		};
	},
	created() {},
	methods: {
		GetOrgInfoListByConfig() {
			GetOrgInfoListByConfig({ key: 1 })
				.then((res) => {
					if (res.code == 1) {
						this.storeList = (res.data || []).map((item) => ({ keyId: item.keyId, value: item.name }));
					}
				})
				.catch(() => {
					this.$message.error("获取门店信息失败!");
				});
		},
		getEnumConfig() {
			GetEnumConfigListByCode({ code: "ProcessType" })
				.then((res) => {
					if (res.code == 1) {
						this.processTypeList = res.data || [];
					}
				})
				.catch(() => {});
			GetEnumConfigListByCode({ code: "MachinType" })
				.then((res) => {
					if (res.code == 1) {
						this.machinTypeList = res.data || [];
					}
				})
				.catch(() => {});
		},
		// type: 1新增 2编辑
		showEditDialog(row, type) {
			this.editType = type;
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.editForm && this.$refs.editForm.clearValidate();
			});
			if (type === 1) {
				this.title = "新建加工订单";
				const raw = this.$options.data.call(this);
				this.editForm = raw.editForm;
				this.customerDisplay = "";
				this.customerInfo = raw.customerInfo;
				this.generateOrderNumber();
			} else {
				this.title = "编辑加工订单";
				this.getInfo(row.keyId);
			}
		},
		generateOrderNumber() {
			GenerateProcessOrderNumber({})
				.then((res) => {
					if (res.code == 1) {
						this.editForm.orderNo = res.data;
					}
				})
				.catch(() => {});
		},
		getInfo(keyId) {
			this.loading = true;
			GetProcessOrderInfo({ keyId: keyId })
				.then((res) => {
					if (res.code == 1) {
						const data = res.data || {};
						this.editForm = {
							keyId: data.keyId,
							orderNo: data.orderNo,
							belongStoreKeyId: data.belongStoreKeyId,
							processType: data.processType,
							customerKeyId: data.customerKeyId,
							orderDate: data.orderDate,
							getOrderDate: data.getOrderDate,
							yanGuangShi: data.yanGuangShi,
							jjInformation: data.jjInformation,
							machinType: data.machinType,
							remark: data.remark,
							dtls: this.buildDtlsFromServer(data.dtls || [])
						};
						this.customerDisplay = data.customerName || "";
						this.customerInfo = Object.assign(this.normalizeCustomerInfo({}), {
							name: data.customerName || "",
							phone: data.customerPhone || ""
						});
						// 订单主表只冗余了顾客姓名与电话，验光参数需按顾客档案补齐
						if (data.customerKeyId) {
							this.loadCustomerDetail(data.customerKeyId);
						}
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 将后端明细归位到固定两行：第 1 行右眼（lr=0）、第 2 行左眼（lr=1）
		buildDtlsFromServer(list) {
			const rows = [buildEmptyDtl(0), buildEmptyDtl(1)];
			const used = [false, false];
			(list || []).forEach((d) => {
				// 优先按左右眼归位；历史脏数据（缺失或重复）则按顺序补位
				let idx = -1;
				if ((d.lr === 0 || d.lr === 1) && !used[d.lr]) {
					idx = d.lr;
				}
				if (idx === -1) {
					idx = used.findIndex((u) => !u);
				}
				if (idx === -1) {
					return;
				}
				used[idx] = true;
				rows[idx] = {
					keyId: d.keyId || "",
					goodsKeyId: d.goodsKeyId || "",
					goodsBrand: d.goodsBrand || "",
					goodsName: d.goodsName || "",
					qiuJing: d.qiuJing,
					zhuJing: d.zhuJing,
					lr: idx, // 行内固定语义：第 0 行右眼、第 1 行左眼
					zhouWei: d.zhouWei || 0,
					quantity: d.quantity > 0 ? d.quantity : 1,
					remark: d.remark || ""
				};
			});
			return rows;
		},
		// 归一化后端返回的顾客信息：lParams/rParams 可能为 null，需回填默认对象，避免模板访问 null 报错
		normalizeCustomerInfo(data) {
			const empty = {
				lParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" },
				rParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" }
			};
			const info = Object.assign({}, data || {});
			info.lParams = Object.assign({}, empty.lParams, (data && data.lParams) || {});
			info.rParams = Object.assign({}, empty.rParams, (data && data.rParams) || {});
			return info;
		},
		// 补齐顾客验光参数（编辑回填时使用）
		loadCustomerDetail(keyId) {
			getCustomerInfoDetail({ keyId: keyId })
				.then((res) => {
					if (res.code == 1) {
						const c = this.normalizeCustomerInfo(res.data);
						this.customerInfo = c;
						this.customerDisplay = (c.name || "") + (c.phone ? "（" + c.phone + "）" : "");
					}
				})
				.catch(() => {});
		},
		// 取顾客指定眼的验光参数；lr：0=右眼 1=左眼
		getCustomerEyeParams(lr) {
			if (!this.customerInfo) {
				return null;
			}
			return lr === 1 ? this.customerInfo.lParams : this.customerInfo.rParams;
		},
		// 转换性别
		transformGender(gender) {
			if (gender == 1) {
				return "男";
			} else if (gender == 0) {
				return "女";
			} else {
				return "--";
			}
		},
		// 判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		},
		handleProcessTypeChange(val) {
			// 丹阳加工确认后直接完成，不涉及出库，前端仅作提示
			if (val === 2) {
				this.$message({ type: "info", message: "丹阳加工订单确认后直接完成，无需出库。" });
			}
		},
		handleSelectCustomer() {
			this.$refs.selectCustomer.showSelectCustomerDialog();
		},
		chooseCustomer(keyId) {
			getCustomerInfoDetail({ keyId: keyId })
				.then((res) => {
					if (res.code == 1) {
						const c = this.normalizeCustomerInfo(res.data);
						this.customerInfo = c;
						this.editForm.customerKeyId = keyId;
						this.customerDisplay = (c.name || "") + (c.phone ? "（" + c.phone + "）" : "");
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("获取顾客信息失败！");
				});
		},
		// 选择指定行的镜片：必须先选顾客；按该眼球预筛球镜/柱镜（右眼取 rParams、左眼取 lParams）
		handleSelectGoods(index) {
			if (!this.editForm.customerKeyId) {
				this.$message({ type: "error", message: "请先选择顾客，再选择镜片！" });
				return;
			}
			const row = this.editForm.dtls[index];
			if (!row) {
				return;
			}
			const eye = this.getCustomerEyeParams(row.lr) || {};
			this.selectDtlIndex = index;
			// type=1 为单选，每行只能选一片镜片
			this.$refs.selectGoods.showSelectGoodsDialog(1, eye.qiuJing || "", eye.zhuJing || "");
		},
		// selectGoods 回调：$parent 即本组件
		chooseGoods(selectionList) {
			if (!selectionList || selectionList.length === 0) {
				return;
			}
			const index = this.selectDtlIndex;
			const row = this.editForm.dtls[index];
			if (!row) {
				return;
			}
			const item = selectionList[0];
			const lr = row.lr; // 左右眼由所在行固定，用户不可改
			const eye = this.getCustomerEyeParams(lr) || {};
			const zhouWei = parseInt(eye.zhouWei);
			this.$set(this.editForm.dtls, index, {
				keyId: row.keyId || "",
				goodsKeyId: item.keyId,
				goodsBrand: item.type,
				goodsName: item.name,
				qiuJing: item.qiuJing,
				zhuJing: item.zhuJing,
				lr: lr,
				zhouWei: isNaN(zhouWei) ? row.zhouWei || 0 : zhouWei,
				quantity: row.quantity > 0 ? row.quantity : 1,
				remark: row.remark || ""
			});
		},
		submitForm() {
			this.$refs.editForm.validate((valid) => {
				if (!valid) {
					return false;
				}
				const dtls = this.editForm.dtls || [];
				if (dtls.length !== 2) {
					this.$message({ type: "warning", message: "加工明细必须为两条：右眼、左眼各一片镜片！" });
					return;
				}
				if (dtls[0].lr === dtls[1].lr) {
					this.$message({ type: "warning", message: "左右眼不能重复，必须一左一右！" });
					return;
				}
				if (dtls.some((d) => !d.goodsKeyId)) {
					this.$message({ type: "warning", message: "请为右眼和左眼各选择一片镜片！" });
					return;
				}
				if (dtls.some((d) => !d.quantity || d.quantity <= 0)) {
					this.$message({ type: "warning", message: "镜片数量必须大于 0！" });
					return;
				}
				if (dtls.some((d) => Number(d.zhouWei) < 0 || Number(d.zhouWei) > 180)) {
					this.$message({ type: "warning", message: "轴位需要在 0-180 范围内！" });
					return;
				}
				var param = {
					keyId: this.editForm.keyId,
					orderNo: this.editForm.orderNo,
					belongStoreKeyId: this.editForm.belongStoreKeyId,
					processType: this.editForm.processType,
					customerKeyId: this.editForm.customerKeyId,
					orderDate: this.editForm.orderDate || null,
					getOrderDate: this.editForm.getOrderDate || null,
					yanGuangShi: this.editForm.yanGuangShi,
					jjInformation: this.editForm.jjInformation,
					machinType: this.editForm.machinType,
					remark: this.editForm.remark,
					dtls: this.editForm.dtls.map((d) => ({
						keyId: d.keyId,
						goodsKeyId: d.goodsKeyId,
						lr: d.lr,
						zhouWei: d.zhouWei || 0,
						quantity: d.quantity,
						remark: d.remark
					}))
				};
				this.saveLoading = true;
				const request = this.editType === 1 ? CreateProcessOrder(param) : EditProcessOrder(param);
				request
					.then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "保存成功！" });
							this.closeDialog();
							this.$parent.search && this.$parent.search();
							this.$emit("refresh-list");
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch(() => {
						this.$message.error("保存失败，请稍后再试！");
					})
					.finally(() => {
						this.saveLoading = false;
					});
			});
		},
		closeDialog() {
			this.showDialog = false;
			this.$refs.editForm && this.$refs.editForm.resetFields();
			const raw = this.$options.data.call(this);
			this.editForm = raw.editForm;
			this.customerDisplay = "";
			this.customerInfo = raw.customerInfo;
			this.selectDtlIndex = 0;
		}
	}
};
</script>

<style scoped>
.detail-block-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px 0;
	font-weight: 600;
}
.detail-tip {
	font-size: 12px;
	font-weight: 400;
	color: var(--app-text-muted);
}
.text-danger {
	color: var(--app-danger);
}
</style>
